import { palette } from './palette';
import yesIcon from '../assets/images/yes-icon.svg';

export const homeStyle = {
  '.hero-link-button, .hero-home-button, .login-button, .secondary-button': {
    borderRadius: '9999px !important',
    textTransform: 'none !important',
    padding: '12px 32px !important',
    minHeight: 'unset !important',
    fontSize: '16px !important',
    '@media (max-width: 430px)': {
      paddingLeft: '12px !important',
      paddingRight: '12px !important',
    },
  },
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
    '& .login-form-container': {
      marginTop: '-96px !important',
    },
    '& .signin-other-link': {
      color: `${palette.text.primary} !important`,
    },
    '& .signin-button': {
      textTransform: 'none !important',
      fontWeight: '400 !important',
      borderRadius: '9999px !important',
    },
    
    '& .login-form-container .section-header': {
      marginBottom: '24px !important',
    },
    '& .login-back-button': {
      color: `${palette.text.primary} !important`,
      border: `1px solid ${palette.background.border} !important`,
      borderRadius: 6,
      padding: '8px 12px',
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .header-phone-link': {
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.surface.pricing,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 500,
      fontFamily: 'Urbanist !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .support-hero-section, & .book-appointment-hero-section':
    {
      marginTop: 88,
      background: `${palette.background.hero1}`,
      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'Urbanist !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
        color: `${palette.text.primary} !important`,
      },
      '& .hero-header-subtitle': {
        color: `${palette.text.primary} !important`,
      },
      '& .section-header__overline-wrapper, & .section-header__label-wrapper': {
        '& .MuiTypography-root': {
          color: `${palette.text.primary} !important`,
        },
      },
      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.primary,
      },
      '& .hero-home-button': {
        backgroundColor: `${palette.background.main} !important`,
        color: `${palette.secondary.main} !important`,
        borderColor: `${palette.secondary.main} !important`,
        '&:hover': {
          borderColor: `${palette.secondary.main} !important`,
        },
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.main,
      '& .hero-link-button, & .login-button': {
        width: '150px !important',
        '@media(max-width: 600px)': {
          width: 'auto !important',
          whiteSpace: 'nowrap !important',
        },
        '@media(max-width: 426px)': {
          width: '100% !important',
        },
      },
      '& .login-button': {
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '@media(max-width: 426px)': {
        '& .section-header__cta-item-wrapper': {
          flexDirection: 'column !important',
          width: '100% !important',
          gap: '12px',
        },
      },
      '@media(min-width: 1200px)': {
        height: '640px',
      },
      '@media(max-width: 1200px)': {
        maxHeight: 'none !important',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: palette.background.heroGradientPanel,
        paddingTop: '0 !important',
        '& .hero-background': {
          position: 'static !important',
          width: '100% !important',
          maxWidth: '100% !important',
          height: 'auto !important',
          maxHeight: '460px',
          objectFit: 'cover',
          objectPosition: 'center top',
          /* Blend the photo into the blue content band below instead of a hard edge */
          maskImage: `linear-gradient(to bottom, black ${palette.effects.heroImageFadeStart}, transparent ${palette.effects.heroImageFadeEnd})`,
          WebkitMaskImage: `linear-gradient(to bottom, black ${palette.effects.heroImageFadeStart}, transparent ${palette.effects.heroImageFadeEnd})`,
          '@media(max-width: 1023px)': {
            maxHeight: '340px !important',
          },
        },
        '& .hero-section': {
          maxHeight: 'none !important',
          overflow: 'visible',
          '& .MuiGrid-item': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
          },
          '& .section-header': {
            marginTop: '-72px !important',
            position: 'relative',
            zIndex: 1,
          },
          '@media(max-width: 1023px)': {
            '& .section-header': {
              marginTop: '-56px !important',
            },
          },
          '@media(max-width: 426px)': {
            '& .section-header': {
              /* Less overlap than tablet — just a light touch on the fade */
              marginTop: '-20px !important',
            },
          },
        },
      },
      '@media(max-width: 600px)': {
        backgroundColor: palette.background.heroGradientPanel,
        paddingTop: '0 !important',
      },
      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.background.main,
        width: '100% !important',
        '@media(min-width: 1200px)': {
          objectPosition: 'left center !important',
        },
        '@media(max-width: 1439px) and (min-width: 768px)': {
          content:
            "url('/images/home-images/home-banner-img-tab.webp')",
        },
        '@media (max-width: 767px)': {
          content:
            "url('/images/home-images/home-banner-img-mobile.webp')",
        },
        '@media screen and (max-width: 600px)': {
          height: '320px !important',
          objectPosition: 'center top !important',
        },
        '@media(max-width: 1200px) and (min-width: 600px)': {
          objectFit: 'cover',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '640px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          width: '58%',
          background: `linear-gradient(to right, transparent 0%, ${palette.background.heroGradientPanel} 55%)`,
          pointerEvents: 'none',
          '@media(max-width: 1200px)': {
            display: 'none',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: palette.background.heroGradientPanel,
          '@media(min-width: 1200px)': {
            backgroundColor: 'transparent',
            paddingRight: '0px !important',
          },
          '@media(max-width: 1200px)': {
            width: '100% !important',
            padding: '0px 50px !important',
            paddingRight: '0px !important',
            '@media(min-width: 600px) and (max-width: 1200px)': {
              padding: '0 !important',
            },
            '@media(max-width: 600px)': {
              padding: '0px 40px !important',
            },
            '@media(max-width: 426px)': {
              padding: '0px 20px !important',
            },
          },
          '& .hero-content-grid': {
            '@media(min-width: 1200px)': {
              justifyContent: 'flex-end !important',
              '& .hero-content-grid-item': {
                flexBasis: '42% !important',
                maxWidth: '42% !important',
              },
            },
          },
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '& .section-header__cta-container': {
            '@media(max-width: 900px)': {
              justifyContent: 'center !important',
            },
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'Urbanist',
        fontWeight: 500,
        maxWidth: 634,
        lineHeight: '72px !important',
        letterSpacing: '-1.28px',
        '@media(max-width: 1439px)': {
          fontSize: '56px !important',
          lineHeight: '64px !important',
          letterSpacing: '-1.12px !important',
          maxWidth: 720,
        },
        '@media(max-width: 767px)': {
          fontSize: '44px !important',
          lineHeight: '52px !important',
          letterSpacing: '-0.88px !important',
          textAlign: 'center !important',
          maxWidth: 480,
        },
      },
      '& .home-hero-subtitle': {
        fontSize: '20px !important',
        maxWidth: 550,
        fontFamily: 'Urbanist',
        fontWeight: 400,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        '@media(max-width: 1439px)': {
          fontSize: '18px !important',
        },
        '@media(max-width: 767px)': {
          fontSize: '16px !important',
          textAlign: 'center !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        '& .hero-section': {
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
          },
          '& .section-header__title': {
            textAlign: 'center !important',
          },
          '& .section-header__subtitle': {
            textAlign: 'center !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
          },
          '& .section-header__cta-wrapper': {
            margin: 'auto',
          },
        },
        '& .home-hero-title': {
          textAlign: 'center !important',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
        '& .home-hero-subtitle': {
          textAlign: 'center !important',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.brandLight,
      '& .definition-variant-2': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '10px !important',
          paddingTop: '10px !important',
        },
        '@media(min-width: 600px) and (max-width: 900px)': {
          padding: '20px !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        padding: ' 0px 20px !important',
      },
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px) and (max-width: 1200px)': {
          padding: '0px 0px 0px',
        },
        '@media (min-width: 1200px)': {
          padding: '0px 48px 0px',
        },

      },
      '& .definition-service-tile': {
        borderBottom: `0.5px solid ${palette.background.border} !important`,
        '& .definition-service-innertile': {
          justifyContent: 'left !important',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',
        paddingTop: '16px !important',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
        '& .image, & img': {
          width: '56px !important',
          height: '56px !important',
        },
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'Urbanist !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
        textAlign: 'left !important',
        paddingBottom: '10px !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
        },
      },

      '& .customIcon': {
        justifyContent: 'left !important',
        paddingBottom: '30px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: palette.text.tertiaryLight,
        textAlign: 'left !important',
        letterSpacing: '-0.32px !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'Urbanist !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.68px !important',
        paddingBottom: '24px !important',
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundRepeat: 'no-repeat, no-repeat',
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'Urbanist !important',
        fontSize: '56px !important',
        lineHeight: '72px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        color: palette.text.highlight,
        '@media screen and (max-width: 900px) and (min-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Urbanist !important',
        fontSize: '20px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: palette.text.highlight,
        '@media screen and (max-width: 700px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .customBenefitsContainer ': {
          fontSize: '16px !important',
        },
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-containedPrimary': {
            backgroundColor: palette.primary.light,
            color: palette.text.tertiary,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.text.highlight,
              transition: 'none !important',
            },
          },
          '& .customGetStarted': {
            fontSize: '16px !important',
          },
          '& .customcardTitle': {
            fontWeight: 500,
            fontFamily: 'Urbanist !important',
            fontSize: '24px !important',
            lineHeight: '28px !important',
            letterSpacing: '-0.64px !important',
            color: palette.text.tertiary,
            '& .MuiSvgIcon-colorPrimary': {
              color: `${palette.text.tertiary} !important`,
            },
          },
          '& .price-value': {
            fontWeight: 500,
            fontSize: '36px !important',
            fontFamily: 'Urbanist !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
            color: palette.text.primary,
            /* Mobile L (425px) */
            '@media(max-width: 425px)': {
              fontSize: '32px !important',
            },
            /* Mobile M (375px) */
            '@media(max-width: 375px)': {
              fontSize: '28px !important',
              lineHeight: '36px !important',
              letterSpacing: '-0.64px !important',
            },
          },
          '& .plan-card-disclaimer-divider': {
            display: 'none !important',
          },
          '@media(max-width: 1279px)': {
            '& .price-item-box .price-item': {
              flex: '1 1 0% !important',
              maxWidth: 'none !important',
            },
          },
          '@media(max-width: 375px)': {
            '& .price-item-box .price-item': {
              flexBasis: '100% !important',
              maxWidth: '100% !important',
            },
            '& .customButtonWrapper, & .cardDivider, & .customBenefitsContainer, & .plan-card-disclaimer-row':
              {
                marginTop: '0 !important',
              },
          },
          '& .price-frequency': {
            fontSize: '14px !important',
          },
          '& .customSubscriberName': {
            fontSize: '14px !important',
          },
          '& .cptCodes': {
            fontSize: '14px !important',
          },
          '& .annual-savings-disclaimer': {
            fontSize: '20px !important',
          },
          '& .customUpfrontWrapper': {
            color: palette.text.tertiaryLight,
            fontWeight: 400,
            lineHeight: '16px !important',
            letterSpacing: '-0.42px !important',
            fontStyle: 'italic',
            '& .activation-fee-amount': {
              fontWeight: 500,
              fontSize: '12px !important',
              color: `${palette.text.secondary} !important`,
              fontFamily: 'Urbanist !important',
            },
            '& .disclaimerText': {
              fontSize: '12px !important',
              fontFamily: 'Urbanist !important',
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .bold': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.secondary} !important`,
          fontFamily: 'Urbanist !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          fontFamily: 'Urbanist !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 500,
          fontSize: '20px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.48px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '& .summary-subtext a': {
          color: `${palette.primary.main} !important`,
          textDecoration: 'underline !important',
          cursor: 'pointer',
        },
        '& .subscription-tabs-label': {
          fontSize: '16px !important',
        },
        '& .subscription-tabs .MuiTab-wrapper': {
          fontSize: '16px !important',
        },
        '@media(min-width: 601px) and (max-width: 1023px)': {
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100% !important',
          },
          '& .react-multi-carousel-list': {
            overflow: 'visible !important',
            height: 'auto !important',
            width: '100% !important',
            maxWidth: '100% !important',
            margin: '0 auto !important',
            padding: '0 !important',
          },
          '& .react-multi-carousel-track': {
            display: 'block !important',
            transform: 'none !important',
            width: '100% !important',
            height: 'auto !important',
          },
          '& .react-multi-carousel-item': {
            display: 'flex !important',
            justifyContent: 'center !important',
            width: '100% !important',
            maxWidth: '100% !important',
            height: 'auto !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            marginBottom: '24px !important',
          },
          '& .plans-carousel-arrow': {
            display: 'none !important',
          },
          '& .react-multiple-carousel__arrow, & .react-multi-carousel-dot-list': {
            display: 'none !important',
          },
          '& .carousel-single-item': {
            justifyContent: 'center !important',
            width: '100% !important',
            maxWidth: '450px !important',
            margin: '0 auto !important',
          },
          '& .subscription-plan-card-item': {
            maxWidth: '100% !important',
            width: '100% !important',
            flexBasis: '100% !important',
          },
          '& .planCard': {
            width: '100% !important',
            maxWidth: '100% !important',
            boxSizing: 'border-box',
          },
        },
        '@media(min-width: 1025px)': {
          '& .react-multi-carousel-track': {
            display: 'flex !important',
            flexWrap: 'wrap !important',
          },
          '& .react-multi-carousel-item:has(.carousel-single-item)': {
            width: '100% !important',
            maxWidth: '100% !important',
            flex: '0 0 100% !important',
          },
          '& .plans-carousel-arrow, & .react-multi-carousel-dot-list': {
            display: 'none !important',
          },
        },
        '& .react-multi-carousel-dot button': {
          border: 'none !important',
          backgroundColor: `${palette.background.border} !important`,
        },
        '& .react-multi-carousel-dot--active button': {
          backgroundColor: `${palette.primary.main} !important`,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.fill,
      '& .section': {
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '40px !important',
        },
        '@media(min-width: 1024px)': {
          padding: '40px 80px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100% !important',
        maxWidth: '100%',
        margin: 0,
        overflow: 'hidden',
        position: 'relative',
        height: 'auto',
        minHeight: 'unset',
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          maxWidth: '100% !important',
          maxHeight: '460px',
          height: 'auto !important',
          minHeight: 'unset !important',
          objectFit: 'contain !important',
          display: 'block !important',
          position: 'relative',
          top: 'auto',
          left: 'auto',
          borderRadius: '24px !important',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Urbanist !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          fontWeight: 500,
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          '@media(max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
        '@media(max-width: 1000px)': {
          paddingTop: '40px !important',
        },
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.tableHead,
        color: palette.text.highlight,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          fontSize: 20,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 500,
          fontFamily: 'Urbanist !important',
          paddingBottom: '8px !important',
          '@media(max-width: 600px)': {
            fontSize: '22px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.44px !important',
          },
        },
        '& .step-content': {
          fontSize: 16,
          color: palette.text.tertiaryLight,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
          '@media(max-width: 1200px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media(min-width: 600px) and (max-width: 1024px)': {
        '& .howitworks-title': {
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
          },
          '& .section-header__title': {
            textAlign: 'center !important',
          },
          '& .section-header__subtitle': {
            textAlign: 'center !important',
          },
        },
        '& .working-steps-container': {
          marginLeft: 'auto',
          marginRight: 'auto',
          '& .step-title': {
            textAlign: 'center !important',
          },
          '& .step-content': {
            textAlign: 'center !important',
          },
        },
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .home-hero-wrapper': {
        backgroundColor: `${palette.background.hero1}`,
        '& .home-hero-title, & .home-hero-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
        '& .primary-button.MuiButton-containedPrimary, & .hero-link-button.MuiButton-containedPrimary':
          {
            background: `${palette.background.main} !important`,
            backgroundColor: `${palette.background.main} !important`,
            color: `${palette.text.primary} !important`,
            boxShadow: 'none !important',
            border: 'none !important',
            borderColor: 'transparent !important',
            '&:hover': {
              background: `${palette.background.main} !important`,
              backgroundColor: `${palette.background.main} !important`,
              color: `${palette.text.primary} !important`,
              borderColor: 'transparent !important',
              opacity: 0.92,
            },
          },
        '& .secondary-button.MuiButton-outlinedPrimary, & .secondary-button.MuiButton-outlinedSecondary, & .login-button.MuiButton-outlinedPrimary, & .login-button.MuiButton-outlinedSecondary':
          {
            background: 'transparent !important',
            backgroundColor: 'transparent !important',
            color: `${palette.text.highlight} !important`,
            border: `1px solid ${palette.text.highlight} !important`,
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.12) !important',
              backgroundColor: 'rgba(255, 255, 255, 0.12) !important',
              color: `${palette.text.highlight} !important`,
              borderColor: `${palette.text.highlight} !important`,
              opacity: 1,
            },
          },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'Urbanist !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Urbanist !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.background.tableAlternate} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.primary.main} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.highlight,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
          '@media(max-width: 600px)': {
            paddingInline: '24px !important',
          },
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '@media(min-width: 600px) and (max-width: 1024px)': {
          paddingInline: '40px !important',
        },
        '@media(min-width: 1024px)': {
          paddingInline: '80px !important',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.background.hero1} !important`,
      },
      '& .section-header__title': {
        fontWeight: 500,
        fontFamily: 'Urbanist !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        color: palette.text.primary,
        marginLeft: '20px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.8px !important',
        color: palette.text.primary,
        marginLeft: '20px !important',
        '@media(max-width: 1200px)': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button': {
          backgroundColor: palette.primary.main,
          color: palette.text.highlight,
          marginRight: '18px !important',
        },
        display: 'flex !important',
        '@media(max-width: 900px)': {
          justifyContent: 'center !important',
        },
        '@media(min-width: 900px) and (max-width: 1200px)': {
          justifyContent: 'center !important',
        },
        '@media(min-width: 1200px)': {
          justifyContent: 'right !important',
        },
      },
      '@media(max-width: 1200px) and (min-width: 600px)': {
        '& .hero-static-section-grid': {
          justifyContent: 'center !important',
        },
        '& .section-header__title': {
          textAlign: 'center !important',
        },
        '& .section-header__subtitle': {
          textAlign: 'center !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Urbanist !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Urbanist !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ — hero typography / spacing (colors + CTAs shared with other inner heroes above) */
    '& .faq-hero-section': {
      '& .hero-header-title': {
        fontFamily: 'Urbanist !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Urbanist !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .faq-get-started.MuiButton-containedPrimary': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        boxShadow: 'none',
        '&:hover': {
          background: `${palette.primary.main} !important`,
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '& .faq-go-to-home-button': {
        background: `${palette.background.main} !important`,
        backgroundColor: `${palette.background.main} !important`,
        color: `${palette.secondary.main} !important`,
        border: `1px solid ${palette.secondary.main} !important`,
        '&:hover': {
          background: `${palette.background.main} !important`,
          backgroundColor: `${palette.background.main} !important`,
          color: `${palette.secondary.main} !important`,
          borderColor: `${palette.secondary.main} !important`,
        },
      },
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: `${palette.text.brandLink} !important`,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.secondary.main} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        paddingInline: '20px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        paddingInline: '40px !important',
      },
      '@media(max-width: 600px) ': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Urbanist !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 500,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.highlight,
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Urbanist !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.highlight,
      },
      '& .provider-contact-link': {
        color: palette.text.highlight,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Urbanist !important',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Urbanist',
        fontWeight: 500,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },
    '& .select-office-button': {
      backgroundColor: 'transparent !important',
      color: `${palette.text.primary} !important`,
      border: `1px solid ${palette.background.border} !important`,
      textTransform: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        borderColor: `${palette.primary.main} !important`,
      },
    },

    '& .zipcode-input-wrapper': {
      border: `1px solid ${palette.background.border} !important`,
      transition: 'border-color 100ms ease, border-width 100ms ease',
      '&:hover': {
        borderColor: `${palette.text.primary} !important`,
      },
      '&:focus-within': {
        borderColor: `${palette.primary.main} !important`,
        borderWidth: '2px !important',
      },
    },

    '& .filter-container': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
    },

    '& .zipcode-filter': {
      marginLeft: '0px',
      '@media (min-width: 1024px)': {
        marginLeft: '20px !important',
      },
      flexBasis: '360px !important',
      maxWidth: '360px !important',
      flexGrow: '0 !important',
      flexShrink: '0 !important',
      '@media (max-width: 400px)': {
        flexBasis: '100% !important',
        maxWidth: '100% !important',
        flexGrow: '1 !important',
        flexShrink: '1 !important',
      },
    },

    '& .card-wrapper svg path': {
      stroke: `${palette.primary.main} !important`,
    },

    '& .summary-content-root': {
      '& .summary-plan-row': {
        background: `linear-gradient(180deg, ${palette.background.hero1} 0%, ${palette.background.default} 100%)`,
      },
      '& .summary-plan-row ~ .summary-plan-row': {
        background: `linear-gradient(180deg, ${palette.background.brandLight} 0%, ${palette.background.default} 100%)`,
      },
    },

    '& .customPromoToggle': {
      color: `${palette.text.brandLink} !important`,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.secondary.main,
      color: palette.text.highlight,
      '& h1, & h2, & h3, & h4, & h5, & h6, & p': {
        color: palette.text.highlight,
      },
    },
    '& .mail-link': {
      color: `${palette.text.brandLink} !important`,
      textDecoration: 'none !important',
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border,
        color: palette.background.border,
      },
    },

    '& .MuiStepIcon-root': {
      width: 32,
      height: 32,
      '&.MuiStepIcon-completed path': {
        fill: 'transparent !important',
      },
      '&.MuiStepIcon-completed': {
        backgroundImage: `url(${yesIcon})`,
        backgroundSize: '20px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: `${palette.text.primary} !important`,
      paddingInline: '40px !important',
      '@media(min-width: 1024px)': {
        paddingInline: '80px !important',
      },
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
      '@media(min-width: 1600px)': {
        maxWidth: '1600px !important',
        margin: '0 auto !important',
      },
      '& a, & .footer-link, & .copyrights-footer-link': {
        color: `${palette.text.primary} !important`,
      },
      '& *': {
        fontSize: '14px !important',
      },
    },
  },
  '.drawer-title-container': {
    backgroundColor: `${palette.primary.main} !important`,
    color: `${palette.text.highlight} !important`,
  },

  '.custom-drawer-wrapper section.checkout_stripe_payment': {
    backgroundColor: `${palette.background.default} !important`,
  },
};
